import type { JobStatus } from "@unbox/db";

export type FailedCreator = {
  creatorId: string;
  error: string;
  retryable: boolean;
};

export type EventDataMap = {
  // Lifecycle
  connected: {};
  heartbeat: { timestamp: string };

  // Bulk action progress
  bulk_action_progress: {
    jobId: string;
    action: string;
    completed: number;
    total: number;
    failures: number;
  };
  bulk_action_complete: {
    jobId: string;
    action: string;
    totalProcessed: number;
    totalFailed: number;
    failedCreators: FailedCreator[];
  };

  // A job's counters moved. Carries the row so a progress bar needs no fetch; anything beyond
  // that is read from the jobs endpoints.
  job_updated: {
    jobId: string;
    kind: string;
    status: JobStatus;
    total: number | null;
    succeeded: number;
    failed: number;
  };

  // Stale-while-revalidate: emitted after a resource has been re-fetched from
  // upstream. The FE invalidates queries keyed off `type` so the next render
  // picks up fresh data via the normal GET path.
  resource_refreshed: {
    type: "collab";
    changedIds: string[];
  };
};

// Create a discriminated union type
export type EventMessage = {
  [K in keyof EventDataMap]: {
    event: K;
  } & EventDataMap[K];
}[keyof EventDataMap];

export type Event = keyof EventDataMap;
export const LIFECYCLE_EVENTS: Event[] = ["connected", "heartbeat"];
